import { TableRoleCell, TableTextCell } from '../../../Table'
import {
  DocFlowTableCellBuilding,
  DocFlowTableCellFlat,
  DocFlowTableCellPagesRange,
  DocFlowTableCellRecipient,
  DocFlowTableCellRecipientStatus,
} from '../../DocFlowTableCell'
import { DocFlowTableRowFile } from '../../DocFlowTableRowFile'
import { DocFlowMappingResultTableCell } from '../DocFlowMappingResultTable'

export function renderCell({
  activeFile,
  item,
  name,
  scrollRef,
  ...restProps
}) {
  const { [name]: value } = item
  const recipientValue = item[DocFlowMappingResultTableCell.Recipient]?.[name]

  switch (name) {
    case DocFlowMappingResultTableCell.Building:
      return (
        <DocFlowTableCellBuilding
          {...restProps}
          scrollRef={scrollRef}
          value={value}
        />
      )

    case DocFlowMappingResultTableCell.Flat:
      return (
        <DocFlowTableCellFlat
          {...restProps}
          item={item}
          scrollRef={scrollRef}
          value={value}
        />
      )

    case DocFlowMappingResultTableCell.File:
      return <DocFlowTableRowFile {...restProps} item={activeFile} />

    case DocFlowMappingResultTableCell.Role:
      return <TableRoleCell {...restProps} value={recipientValue} />

    case DocFlowMappingResultTableCell.Status:
      return (
        <DocFlowTableCellRecipientStatus
          {...restProps}
          value={recipientValue}
        />
      )

    case DocFlowMappingResultTableCell.Recipient:
      return (
        <DocFlowTableCellRecipient
          {...restProps}
          infoText='DocumentStapling.DuplicateInfoTextKey'
          value={value}
          withInfo={item[DocFlowMappingResultTableCell.HasDuplicate]}
        />
      )

    case DocFlowMappingResultTableCell.PagesCount:
      return <TableTextCell {...restProps} value={value} />

    case DocFlowMappingResultTableCell.PagesRange:
      return <DocFlowTableCellPagesRange {...restProps} value={value} />

    default:
      break
  }
}
